// extracted by mini-css-extract-plugin
module.exports = {"confirmModalBody":"RemarkModal_confirmModalBody__2kVOj","operateHintText":"RemarkModal_operateHintText__1bF-e","disabledTip":"RemarkModal_disabledTip__3L_OU"};